import { render, staticRenderFns } from "./PropertyString.vue?vue&type=template&id=60e8e38a"
import script from "./PropertyString.vue?vue&type=script&lang=js"
export * from "./PropertyString.vue?vue&type=script&lang=js"
import style0 from "./PropertyString.vue?vue&type=style&index=0&id=60e8e38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports